import { IconProps } from "./IconProps";

const PencilIcon: React.FC<IconProps> = ({
  width = 24,
  height = 24,
  color = "#FFFFFF",
}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 19 18" fill="none">
      <path
        d="M2.84375 15.5884V12.4773L12.5063 2.83302C12.6528 2.69882 12.8144 2.59511 12.9913 2.52191C13.1682 2.44871 13.3543 2.41211 13.5495 2.41211C13.7447 2.41211 13.9338 2.44871 14.1168 2.52191C14.2998 2.59511 14.4584 2.70492 14.5926 2.85132L15.5991 3.87614C15.7455 4.01034 15.8523 4.16895 15.9194 4.35195C15.9865 4.53495 16.02 4.71796 16.02 4.90096C16.02 5.09616 15.9865 5.28222 15.9194 5.45912C15.8523 5.63603 15.7455 5.79768 15.5991 5.94408L5.95481 15.5884H2.84375ZM13.5312 5.92578L14.556 4.90096L13.5312 3.87614L12.5063 4.90096L13.5312 5.92578Z"
        fill={color}
      />
    </svg>
  );
};
export default PencilIcon;
